<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M21 2C20.3597 2 19.7456 2.25435 19.2929 2.70711L16.4004 5.59964C16.152 5.84802 15.7915 5.94787 15.4507 5.86268L4 3L2.98106 4.01894C2.59053 4.40947 2.59053 5.04263 2.98106 5.43316C3.05706 5.50916 3.14482 5.57241 3.24095 5.62048L12 10L8 14H3.61803C3.23926 14 2.893 14.214 2.72361 14.5528L2 16L6 18L8 22L9.44721 21.2764C9.786 21.107 10 20.7607 10 20.382V16L14 12L18.3795 20.759C18.6265 21.253 19.2272 21.4533 19.7212 21.2063C19.8173 21.1582 19.9051 21.0949 19.9811 21.0189L21 20L18.1373 8.54929C18.0521 8.20851 18.152 7.84802 18.4004 7.59964L21.2929 4.70711C21.7456 4.25435 22 3.64029 22 3C22 2.44772 21.5523 2 21 2Z"
    fill="currentColor"
  />
</svg>
